(function () {
    "use strict";

    angular.module("app").component("habilFormError", {
        transclude: true,
        bindings: {
            condition: "<"
        },
        template: `<div role="alert" style="border-top: 3px solid red; color: red" ng-if="$ctrl.condition"><ng-transclude></ng-transclude></div>`
    });
})();